/**
 * Confirm Dialog Component
 * Reusable confirmation dialog for destructive actions
 */

import React from 'react';
import { Modal } from './Modal';
import { useUIStore } from '@flow-studio/store'; // import { uiStore';
import { Button } from '../Shared/FormUI';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger',
}) => {
  const { theme } = useUIStore();

  // Debug: Log when component renders
  React.useEffect(() => {
  }, [isOpen]);

  const messageStyle: React.CSSProperties = {
    fontSize: '16px',
    color: theme === 'dark' ? '#e5e7eb' : '#374151',
    marginBottom: '24px',
    lineHeight: '1.6',
  };

  const buttonsStyle: React.CSSProperties = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="480px">
      <div style={messageStyle}>{message}</div>
      <div style={buttonsStyle}>
        <Button variant="secondary" onClick={onClose}>{cancelText}</Button>
        <Button
          variant={type === 'danger' ? 'danger' : 'primary'}
          style={type === 'warning' ? { background: '#f59e0b', border: 'none' } : undefined}
          onClick={handleConfirm}
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
};
